import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-financial-subnav',
    templateUrl: './financial-subnav.component.html',
    styleUrls: ['./financial-subnav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FinancialSubnavComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
